export const repeatingGradient = (color: string) => `repeating-linear-gradient(
    45deg,
    ${color}20,
    ${color}20 10px,
    ${color}40 10px,
    ${color}40 20px
  )`;
